// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jIgl","rootParamsCollapsed":"styles_rootParamsCollapsed___DMFC","rootPreviewFull":"styles_rootPreviewFull__2oTu1","loader":"styles_loader__ZQaTR"};